// extracted by mini-css-extract-plugin
export default {"header":"header_header__i20ez","header_logo":"header_header_logo__9YTtu","header_navigation":"header_header_navigation__MhFt4"};